import type { HasBackgroundColor } from "../pixel-accessor";
import type { Color } from "../types";
import type { ColorInterpolator } from "./ColorInterpolator";

/**
 * Background Color interpolator. Used for debugging EWA failures.
 */
export class BackgroundInterpolator implements ColorInterpolator {
  /**
   * Returns image background color.
   *
   * @param image
   */
  interpolate(image: HasBackgroundColor): Color {
    return image.getBackgroundColor();
  }
}
